import type { EvidenceDocumentStatus } from './model';

/** v1 / API document status strings (`AWAITING_APPROVAL`, …) → domain status. */
export function evidenceDocumentStatusFromWire(
  raw: string | number | null | undefined
): EvidenceDocumentStatus {
  const normalized = String(raw ?? '').toUpperCase();
  switch (normalized) {
    case 'APPROVED':
      return 'approved';
    case 'PAID':
      return 'paid';
    case 'DECLINED':
      return 'declined';
    case 'AWAITING_APPROVAL':
    default:
      return 'awaiting';
  }
}

export function isEvidenceDocumentStatus(
  value: string
): value is EvidenceDocumentStatus {
  return (
    value === 'awaiting' ||
    value === 'approved' ||
    value === 'paid' ||
    value === 'declined'
  );
}
